import { createFileRoute } from "@tanstack/react-router";
import { PROJECT } from "@/app/capabilities/permissions";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth"
)({
  beforeLoad: (ctx) =>
    requireProjectPermission(ctx, PROJECT.authProviders.read),
  loader: () => ({
    crumb: "OAuth Providers",
  }),
});
